var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              permission: _vm.permissionList,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "search-change": _vm.searchChange,
              "refresh-change": _vm.refreshChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }